(() => {
  'use strict';

  const DURATION = 46.4;
  const UPDATE_MS = 125;
  const PALETTE = [
    [0.0,[255,14,0]], [4.0,[255,0,92]], [8.0,[254,0,182]],
    [12.0,[187,0,255]], [16.0,[110,0,254]], [20.0,[0,180,255]],
    [24.0,[0,253,240]], [28.0,[0,254,147]], [32.0,[20,255,0]],
    [36.0,[239,252,0]], [40.0,[255,166,0]], [44.0,[255,75,0]],
    [46.4,[255,14,0]]
  ];

  let video = null;
  let fallbackStart = performance.now();
  let timer = 0;
  let themeTransitioning = false;
  let visibleRgbTargets = 0;
  let visibilityObserver = null;

  function colorAt(time) {
    const t = ((time % DURATION) + DURATION) % DURATION;
    for (let i = 0; i < PALETTE.length - 1; i++) {
      const a = PALETTE[i], b = PALETTE[i + 1];
      if (t >= a[0] && t <= b[0]) {
        const p = (t - a[0]) / (b[0] - a[0] || 1);
        return a[1].map((v, j) => Math.round(v + (b[1][j] - v) * p));
      }
    }
    return PALETTE[0][1];
  }

  function applyColor([r,g,b]) {
    const root = document.documentElement;
    const luminance = (0.2126*r + 0.7152*g + 0.0722*b) / 255;
    root.style.setProperty('--jaafers-rgb-sync', `rgb(${r} ${g} ${b})`);
    root.style.setProperty('--jaafers-rgb-shadow', `rgb(${r} ${g} ${b} / .30)`);
    root.style.setProperty('--jaafers-rgb-slider-edge', `rgb(${r} ${g} ${b} / .72)`);
    root.style.setProperty('--jaafers-rgb-slider-shadow', `rgb(${r} ${g} ${b} / .16)`);
    root.style.setProperty('--jaafers-rgb-contrast', luminance > .62 ? '#111111' : '#ffffff');
  }


  function locateVideo() {
    const slider = document.querySelector('#MainContent [data-section-name="slider"] main-slider, [data-section-name="slider"] main-slider');
    const found = slider?.querySelector('.swiper-slide:first-child video.slide-video') || slider?.querySelector('video.slide-video') || null;
    if (found !== video) {
      video = found;
      if (video) {
        ['loadedmetadata','play','pause','seeked'].forEach(evt => video.addEventListener(evt, update, {passive:true}));
      }
    }
    return video;
  }

  function update() {
    if (document.hidden || themeTransitioning) return;
    if (!video || !document.contains(video)) locateVideo();

    // The video timeline is always the source of truth, even when the browser pauses it off-screen.
    // This prevents the logo from drifting and then snapping back when returning to the header.
    if (video && video.readyState >= 1 && !video.paused && !video.ended) {
      const t = Number.isFinite(video.currentTime) ? video.currentTime : 0;
      fallbackStart = performance.now() - t * 1000;
      applyColor(colorAt(t));
      return;
    }

    applyColor(colorAt((performance.now() - fallbackStart) / 1000));
  }

  function stop() {
    if (!timer) return;
    clearInterval(timer);
    timer = 0;
  }

  function start() {
    if (document.hidden || themeTransitioning || timer) return;
    update();
    timer = window.setInterval(update, UPDATE_MS);
  }

  function init() {
    applyColor(PALETTE[0][1]);
    locateVideo();

    const targets = document.querySelectorAll(
      '.header__heading-logo--svg, .footer__link__logo, .btn--addtocart-page, #CartDrawer-Checkout, #checkout, section-slider.jaafers-rgb-master-slider, .jsh-about-rgb-target'
    );

    if ('IntersectionObserver' in window && targets.length) {
      visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const wasVisible = entry.target.dataset.jshRgbVisible === '1';
          const isVisible = entry.isIntersecting;
          if (isVisible && !wasVisible) {
            entry.target.dataset.jshRgbVisible = '1';
            visibleRgbTargets++;
          } else if (!isVisible && wasVisible) {
            entry.target.dataset.jshRgbVisible = '0';
            visibleRgbTargets = Math.max(0, visibleRgbTargets - 1);
          }
        });
        start();
      }, { rootMargin: '120px 0px', threshold: 0.01 });

      targets.forEach((target) => visibilityObserver.observe(target));
    } else {
      visibleRgbTargets = 1;
      start();
    }

    document.addEventListener('jsh:theme-transition-start', () => {
      themeTransitioning = true;
      stop();
    });

    document.addEventListener('jsh:theme-transition-end', () => {
      themeTransitioning = false;
      update();
      start();
    });

    document.addEventListener('shopify:section:load', () => {
      locateVideo();
      update();
    });

    document.addEventListener('visibilitychange', () => {
      document.hidden ? stop() : start();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
